import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { MasterSlot, ShopMaxPerDay, ShopMaxPerTime, PerDaySlotsForCustomData, TeamMaxPerTime, TechnicianSlotsPerTeam, ActivateIndicator, TechnicianActivateIndicator, ShuttleActivateIndicator, RentalActivateIndicator, RemoteActivateIndicator} from './../../shared/models/slot-management.model';
import produce from 'immer';
import * as fromActions from './slot.actions';
import * as fromAdapter from './slot.adapter';
import { IAsyncData } from '../../shared/models/base.model';
import { TransportationType } from '@signal/asp-data-commons';


export interface IMasterSlots extends IAsyncData {
    data: MasterSlot[];
}

export interface IShopMaxTotalDetails extends IAsyncData {
    data: ShopMaxPerDay[];
    isUpdated:boolean,
}

export interface IShopMaxSlotDetails extends IAsyncData {
    data: ShopMaxPerTime;
    isUpdated:boolean,
}

export interface ITeamMaxTotalDetails extends IAsyncData {
    data: PerDaySlotsForCustomData[];
    isUpdated:boolean,
}

export interface ITeamMaxSlotDetails extends IAsyncData {
    data: TeamMaxPerTime[];
    isUpdated:boolean,
}

export interface ITechnicianTotalDetails extends IAsyncData {
    data: PerDaySlotsForCustomData[];
}

export interface ITechnicianSlotDetails extends IAsyncData {
    data: TechnicianSlotsPerTeam[];
}

export interface ITransportDetails extends IAsyncData {
    data: PerDaySlotsForCustomData[];
}

export interface ITransportMaxTotalDetails extends IAsyncData {
    data: ShopMaxPerDay[],
    isUpdated:boolean,
}

export interface ITransportMaxSlotDetails extends IAsyncData {
    data: ShopMaxPerTime,
    isUpdated:boolean,
}

export interface IActivateIndicators extends IAsyncData {
    data: ActivateIndicator[];
}

export interface ITechnicianActivateIndicators extends IAsyncData {
    data: TechnicianActivateIndicator[];
}

export interface IShuttleActivateIndicators extends IAsyncData {
    data: ShuttleActivateIndicator[];
}

export interface IRentalActivateIndicators extends IAsyncData {
    data: RentalActivateIndicator[];
}



export interface IRemoteActivateIndicators extends IAsyncData {
    data: RemoteActivateIndicator[];
}

export interface SlotState extends EntityState<any> {
    // additional entities state properties
    loading: boolean,
    loaded: boolean,
    error: string,
    masterSlots: IMasterSlots,
    shopMaxTotal: IShopMaxTotalDetails,
    shopMaxSlots: IShopMaxSlotDetails,
    teamMaxTotal: ITeamMaxTotalDetails,
    teamMaxSlots: ITeamMaxSlotDetails,
    technicianTotal: ITechnicianTotalDetails,
    technicianSlots: ITechnicianSlotDetails,
    shuttleMaxTotal: ITransportMaxTotalDetails,
    shuttleMaxSlots: ITransportMaxSlotDetails,
    rentalMaxTotal: ITransportMaxTotalDetails,
    rentalMaxSlots: ITransportMaxSlotDetails,
    remoteMaxTotal: ITransportMaxTotalDetails,
    remoteMaxSlots: ITransportMaxSlotDetails,
    activateIndicators: IActivateIndicators,
    technicianactivateIndicators: ITechnicianActivateIndicators,
    shuttleactivateIndicators: IShuttleActivateIndicators,
    rentalactivateIndicators: IRentalActivateIndicators,
    remoteactivateIndicators: IRemoteActivateIndicators,
    indicator: any,
    txmTeamMaxTotal: ITransportMaxTotalDetails,
    txmTeamMaxSlots: ITransportMaxSlotDetails,
    txmActivateIndicators: IActivateIndicators,
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: SlotState = adapter.getInitialState({
    loading: false,
    loaded: false,
    error: '',
    masterSlots: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    shopMaxTotal: {
        data: [],
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true
    },
    shopMaxSlots: {
        data: {} as ShopMaxPerTime,
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true
    },
    teamMaxTotal: {
        data: [],
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true
    },
    teamMaxSlots: {
        data: [],
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true
    },
    technicianTotal: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    technicianSlots: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    shuttleMaxTotal: {
        data: [],
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },
    shuttleMaxSlots: {
        data: {} as ShopMaxPerTime,
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },

    rentalMaxTotal: {
        data: [],
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },
    rentalMaxSlots: {
        data: {} as ShopMaxPerTime,
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },
    remoteMaxTotal: {
        data: [],
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },
    remoteMaxSlots: {
        data: {} as ShopMaxPerTime,
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },
    activateIndicators: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    technicianactivateIndicators: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    shuttleactivateIndicators: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    rentalactivateIndicators: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },

    remoteactivateIndicators: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
    indicator: {
        data: {indicator:false},
        loading: false,
        loaded: false,
        error: ''
    },
    txmTeamMaxTotal: {
        data: [],
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },
    txmTeamMaxSlots: {
        data: {} as ShopMaxPerTime,
        loading: false,
        loaded: false,
        error: '',
        isUpdated:true,
    },
    txmActivateIndicators: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    },
});

export function slotReducer(state: SlotState = initialState,
    action: fromActions.SlotActions): SlotState {

    switch (action.type) {

        case fromActions.SlotActionTypes.LOAD_MASTER_SLOTS: {
            return produce(state, draftState => {
                draftState.masterSlots = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                } 
            });
        }
        case fromActions.SlotActionTypes.LOAD_MASTER_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadMasterSlotsSuccess ? action.payload : undefined;
                draftState.masterSlots = {
                    data: payload.masterSlots,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_MASTER_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadMasterSlotsFailure ? action.payload : undefined;
                draftState.masterSlots = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHOP_MAX_SLOTS: {
            return produce(state, draftState => {
                draftState.shopMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: true,
                    loaded: false,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHOP_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadShopMaxSlotsSuccess ? action.payload : undefined;
                draftState.shopMaxSlots = {
                    data: payload.shopMaxSlots,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHOP_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadShopMaxSlotsFailure ? action.payload : undefined;
                draftState.shopMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHOP_MAX_TOTAL: {
            return produce(state, draftState => {
                draftState.shopMaxTotal = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: '',
                    isUpdated:true
                } 
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHOP_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadShopMaxTotalSuccess ? action.payload : undefined;
                draftState.shopMaxTotal = {
                    data: payload.shopMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHOP_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadShopMaxTotalFailure ? action.payload : undefined;
                draftState.shopMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHOP_MAX_SLOTS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShopMaxSlots ? action.payload : undefined;
                draftState.shopMaxSlots = {
                    ...state.shopMaxSlots,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHOP_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShopMaxSlotsSuccess ? action.payload : undefined;
                draftState.shopMaxSlots = {
                    data: payload.shopMaxSlots,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHOP_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShopMaxSlotsFailure ? action.payload : undefined;
                draftState.shopMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHOP_MAX_TOTAL: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShopMaxTotal ? action.payload : undefined;
                draftState.shopMaxTotal = {
                    data: payload.shopMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHOP_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShopMaxTotalSuccess ? action.payload : undefined;
                draftState.shopMaxTotal = {
                    data: payload.shopMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHOP_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShopMaxTotalFailure ? action.payload : undefined;
                draftState.shopMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }

        /* team capacity */
        case fromActions.SlotActionTypes.LOAD_TEAM_MAX_SLOTS: {
            return produce(state, draftState => {
                draftState.teamMaxSlots = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TEAM_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTeamMaxSlotsSuccess ? action.payload : undefined;
                draftState.teamMaxSlots = {
                    data: payload.teamMaxSlots,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TEAM_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTeamMaxSlotsFailure ? action.payload : undefined;
                draftState.teamMaxSlots = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TEAM_MAX_TOTAL: {
            return produce(state, draftState => {
                draftState.teamMaxTotal = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TEAM_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTeamMaxTotalSuccess ? action.payload : undefined;
                draftState.teamMaxTotal = {
                    data: payload.teamMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TEAM_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTeamMaxTotalFailure ? action.payload : undefined;
                draftState.teamMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TEAM_MAX_SLOTS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTeamMaxSlots ? action.payload : undefined;
                // const index = state.teamMaxSlots.data.findIndex(x => x.teamId == payload.teamMaxSlots.teamId);
                // const teamMaxSlots = [...state.teamMaxSlots.data];
                // teamMaxSlots.splice(index, 1, payload.teamMaxSlots);

                draftState.teamMaxSlots = {
                    ...state.teamMaxSlots,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TEAM_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTeamMaxSlotsSuccess ? action.payload : undefined;
                const index = state.teamMaxSlots.data.findIndex(x => x.teamId === payload.teamMaxSlots.teamId);
                const teamMaxSlots = [...state.teamMaxSlots.data];
                teamMaxSlots.splice(index, 1, payload.teamMaxSlots);

                draftState.teamMaxSlots = {
                    data: teamMaxSlots,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TEAM_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTeamMaxSlotsFailure ? action.payload : undefined;
                draftState.teamMaxSlots = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TEAM_MAX_TOTAL: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTeamMaxTotal ? action.payload : undefined;
                draftState.teamMaxTotal = {
                    data: payload.teamMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TEAM_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTeamMaxTotalSuccess ? action.payload : undefined;
                draftState.teamMaxTotal = {
                    data: payload.teamMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TEAM_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTeamMaxTotalFailure ? action.payload : undefined;
                draftState.teamMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }

        /*techniican capacity */
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_SLOTS: {
            return produce(state, draftState => {
                draftState.technicianSlots = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTechnicianMaxSlotsSuccess ? action.payload : undefined;
                draftState.technicianSlots = {
                    data: payload.technicianMaxSlots,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTechnicianMaxSlotsFailure ? action.payload : undefined;
                draftState.technicianSlots = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_TOTAL: {
            return produce(state, draftState => {
                draftState.technicianTotal = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTechnicianMaxTotalSuccess ? action.payload : undefined;
                draftState.technicianTotal = {
                    data: payload.technicianMaxTotal,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTechnicianMaxTotalFailure ? action.payload : undefined;
                draftState.technicianTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_SLOTS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianMaxSlots ? action.payload : undefined;
                const index = state.technicianSlots.data.findIndex(x => x.teamId === payload.technicianMaxSlots.teamId);
                const techMaxSlots = [...state.technicianSlots.data];
                techMaxSlots.splice(index, 1, payload.technicianMaxSlots);
                draftState.technicianSlots = {
                    data: techMaxSlots,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianMaxSlotsSuccess ? action.payload : undefined;
                const index = state.technicianSlots.data.findIndex(x => x.teamId === payload.technicianMaxSlots.teamId);
                const techMaxSlots = [...state.technicianSlots.data];
                techMaxSlots.splice(index, 1, payload.technicianMaxSlots);
                draftState.technicianSlots = {
                    data: techMaxSlots,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianMaxSlotsFailure ? action.payload : undefined;
                draftState.technicianSlots = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_TOTAL: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianMaxTotal ? action.payload : undefined;
                draftState.technicianTotal = {
                    data: payload.technicianMaxTotal,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianMaxTotalSuccess ? action.payload : undefined;
                draftState.technicianTotal = {
                    data: payload.technicianMaxTotal,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianMaxTotalFailure ? action.payload : undefined;
                draftState.technicianTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }

        /* Transport Capacity */
        case fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_SLOTS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTransportMaxSlots ? action.payload : undefined;
                fromAdapter.setTransportMaxSlotsLoading(draftState, payload);
            });
        }
        case fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTransportMaxSlotsSuccess ? action.payload : undefined;
                fromAdapter.setTransportMaxSlots(draftState, payload);
            });
        }
        case fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTransportMaxSlotsFailure ? action.payload : undefined;
                draftState.remoteMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true,
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_TOTAL: {
            return produce(state, draftState => {
                draftState.remoteMaxTotal = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: '',
                    isUpdated:true,
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTransportMaxTotalSuccess ? action.payload : undefined;
                fromAdapter.setTransportMaxTotal(draftState, payload);
            });
        }
        case fromActions.SlotActionTypes.LOAD_TRANSPORT_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTransportMaxTotalFailure ? action.payload : undefined;
                draftState.remoteMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true,
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_SLOTS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTransportMaxSlots ? action.payload : undefined;
                 fromAdapter.setTransportMaxSlots(draftState, payload);
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTransportMaxSlotsSuccess ? action.payload : undefined;
                fromAdapter.setTransportMaxSlots(draftState, payload);
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTransportMaxSlotsFailure ? action.payload : undefined;
                draftState.remoteMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_TOTAL: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTransportMaxTotal ? action.payload : undefined;
                fromAdapter.setTransportMaxTotal(draftState, payload);
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTransportMaxTotalSuccess ? action.payload : undefined;
                fromAdapter.setTransportMaxTotal(draftState, payload);
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TRANSPORT_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTransportMaxTotalFailure ? action.payload : undefined;
                draftState.remoteMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.activateIndicators = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.activateIndicators = {
                    data: payload.activateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadActivateIndicatorsFailure ? action.payload : undefined;
                draftState.activateIndicators = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.indicator = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.indicator = {
                    data: payload.activateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateActivateIndicatorsFailure ? action.payload : undefined;
                draftState.indicator = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.technicianactivateIndicators = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTechnicianActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.technicianactivateIndicators = {
                    data: payload.technicianactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TECHNICIAN_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTechnicianActivateIndicatorsFailure ? action.payload : undefined;
                draftState.technicianactivateIndicators = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.indicator = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.indicator = {
                    data: payload.technicianactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TECHNICIAN_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTechnicianActivateIndicatorsFailure ? action.payload : undefined;
                draftState.indicator = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHUTTLE_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.shuttleactivateIndicators = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHUTTLE_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadShuttleActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.shuttleactivateIndicators = {
                    data: payload.shuttleactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_SHUTTLE_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadShuttleActivateIndicatorsFailure ? action.payload : undefined;
                draftState.shuttleactivateIndicators = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHUTTLE_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.indicator = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHUTTLE_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShuttleActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.indicator = {
                    data: payload.shuttleactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_SHUTTLE_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShuttleActivateIndicatorsFailure ? action.payload : undefined;
                draftState.indicator = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_RENTAL_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.rentalactivateIndicators = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_RENTAL_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadRentalActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.rentalactivateIndicators = {
                    data: payload.rentalactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_RENTAL_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadRentalActivateIndicatorsFailure ? action.payload : undefined;
                draftState.rentalactivateIndicators = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_RENTAL_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.indicator = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_RENTAL_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateRentalActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.indicator = {
                    data: payload.rentalactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_RENTAL_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateRentalActivateIndicatorsFailure ? action.payload : undefined;
                draftState.indicator = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }

       
        case fromActions.SlotActionTypes.LOAD_REMOTE_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.remoteactivateIndicators = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_REMOTE_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadRemoteActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.remoteactivateIndicators = {
                    data: payload.remoteactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_REMOTE_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadRemoteActivateIndicatorsFailure ? action.payload : undefined;
                draftState.remoteactivateIndicators = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_REMOTE_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.indicator = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_REMOTE_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateRemoteActivateIndicatorsSuccess ? action.payload : undefined;
                draftState.indicator = {
                    data: payload.remoteactivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_REMOTE_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateRemoteActivateIndicatorsFailure ? action.payload : undefined;
                draftState.indicator = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        /* TXM team capacity */
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_SLOTS: {
            return produce(state, draftState => {
                draftState.txmTeamMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: true,
                    loaded: false,
                    error: '',
                    isUpdated:true,
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTxmTeamMaxSlotsSuccess ? action.payload : undefined;
                draftState.txmTeamMaxSlots = {
                    data: payload.txmTeamMaxSlots,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true,
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTxmTeamMaxSlotsFailure ? action.payload : undefined;
                draftState.txmTeamMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_TOTAL: {
            return produce(state, draftState => {
                draftState.txmTeamMaxTotal = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: '',
                    isUpdated:true

                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTxmTeamMaxTotalSuccess ? action.payload : undefined;
                draftState.txmTeamMaxTotal = {
                    data: payload.txmTeamMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTxmTeamMaxTotalFailure ? action.payload : undefined;
                draftState.txmTeamMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:true
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_SLOTS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateShopMaxSlots ? action.payload : undefined;
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_SLOTS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTxmTeamMaxSlotsSuccess ? action.payload : undefined;
                draftState.txmTeamMaxSlots = {
                    data: payload.txmTeamMaxSlots,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true,
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_SLOTS_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTxmTeamMaxSlotsFailure ? action.payload : undefined;
                draftState.txmTeamMaxSlots = {
                    data: {} as ShopMaxPerTime,
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_TOTAL: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTxmTeamMaxTotal ? action.payload : undefined;
                draftState.txmTeamMaxTotal = {
                    data: payload.txmTeamMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:false,
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_TOTAL_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTxmTeamMaxTotalSuccess ? action.payload : undefined;
                draftState.txmTeamMaxTotal = {
                    data: payload.txmTeamMaxTotal,
                    loading: false,
                    loaded: true,
                    error: '',
                    isUpdated:true,
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_MAX_TOTAL_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTxmTeamMaxTotalFailure ? action.payload : undefined;
                draftState.txmTeamMaxTotal = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error,
                    isUpdated:false
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.txmActivateIndicators = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTxmTeamActivateIndicatorSuccess ? action.payload : undefined;
                draftState.txmActivateIndicators = {
                    data: payload.txmActivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.LOAD_TXM_TEAM_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadTxmTeamActivateIndicatorFailure ? action.payload : undefined;
                draftState.txmActivateIndicators = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_ACTIVATE_INDICATOR: {
            return produce(state, draftState => {
                draftState.indicator = {
                    data: [],
                    loading: true,
                    loaded: false,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_ACTIVATE_INDICATOR_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTxmTeamActivateIndicatorSuccess ? action.payload : undefined;
                draftState.indicator = {
                    data: payload.txmActivateIndicators,
                    loading: false,
                    loaded: true,
                    error: ''
                }
            });
        }
        case fromActions.SlotActionTypes.UPDATE_TXM_TEAM_ACTIVATE_INDICATOR_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateTxmTeamActivateIndicatorFailure ? action.payload : undefined;
                draftState.indicator = {
                    data: [],
                    loading: false,
                    loaded: true,
                    error: payload.error
                }
            });
        }
        default:
            return state;
    }
}



